import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Img from "gatsby-image";
import Fade from "react-reveal/Fade";

import styles from "./Header.module.scss";
import backgroundVideoMp4 from "../../video/brillante-vielse.mp4";

import Button from "../Button";

const HEADER_QUERY = graphql`
  query HeaderQuery {
    logo: file(relativePath: { eq: "logo/Brillante_Logo_hvit.png" }) {
      childImageSharp {
        fixed(width: 200, height: 73) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    markdownRemark(frontmatter: { templateKey: { eq: "header" } }) {
      frontmatter {
        title
        subtitle
      }
    }
  }
`;

export default function header() {
  return (
    <StaticQuery
      query={HEADER_QUERY}
      render={data => {
        const { markdownRemark: section } = data;
        return (
          <HeaderTemplate
            title={section.frontmatter.title}
            subtitle={section.frontmatter.subtitle}
            logo={data.logo.childImageSharp.fixed}
          />
        );
      }}
    />
  );
}

export class HeaderTemplate extends Component {
  render() {
    const { title, subtitle, logo, logoFile } = this.props;
    return (
      <header id="hjem" className={styles.header}>
        <div className={styles.headerVideoContainer}>
          <Fade delay={500} duration={2000}>
            <div className={styles.videoBackground}>
              <div className={styles.videoForeground}>
                <video autoPlay preload="auto" loop muted playsInline>
                  <source src={backgroundVideoMp4} type="video/mp4" />
                </video>
              </div>
            </div>
          </Fade>
        </div>
        <div className={styles.headerContentContainer}>
          <div className={styles.headerContent}>
            <div className={styles.contentArea}>
              <Fade bottom>
                <div className={styles.brand}>
                  {logo ? (
                    <Img fixed={logo} alt="" />
                  ) : (
                    <img src={logoFile} width="158px" alt="" />
                  )}
                </div>
                <h1>{title}</h1>
                <p className={styles.subtitle}>{subtitle}</p>
              </Fade>
            </div>
            <Button component={AnchorLink} href="#events" outline={true}>
              Finn ut mer
            </Button>
          </div>
        </div>
      </header>
    );
  }
}
